module.exports = __webpack_public_path__ + "static/media/beerpong.7d4e7fe3.svg";